export {default} from './AtlasDevice';
